// extracted by mini-css-extract-plugin
module.exports = {"icon":"_base-icon_icon_IgFb-","clickable":"_base-icon_clickable_2xl4O"};